import { OnUpdateCriteriaFieldOptions } from '@widgets/SearchAssistant/model/types'
import { SearchAssistantPresenter } from '@widgets/SearchAssistant/presenter/search-assistant.presenter'

import { CriteriaType, ValueAddType } from '@constants'
import { AutocompleteOption } from '@types'

import { CriteriaFields } from './CriteriaFields'

interface UnpinnedCriteriaFieldsProps {
  searchAssistantPresenter: SearchAssistantPresenter
  criterias: CriteriaType[]
  visibleCriterias: CriteriaType[]
  disabled: boolean
  onUpdateAutocomplete: (
    newCriteria: CriteriaType,
    newValue: AutocompleteOption,
    options: OnUpdateCriteriaFieldOptions
  ) => void
  onUpdateCriteriaValue: (value: ValueAddType) => void
}

export const UnpinnedCriteriaFields: React.FC<UnpinnedCriteriaFieldsProps> = props => {
  const {
    searchAssistantPresenter,
    criterias,
    visibleCriterias,
    disabled,
    onUpdateAutocomplete,
    onUpdateCriteriaValue: handleUpdateCriteriaValue,
  } = props

  const unpinnedCriterias = searchAssistantPresenter.getUnpinnedCriteriaFields(criterias)
  const visibleUnpinnedCriteriaFields =
    searchAssistantPresenter.getVisibleUnpinnedCriteriaFields(visibleCriterias)

  const handleUpdateAutocomplete = (newCriteria: CriteriaType, newValue: AutocompleteOption) => {
    onUpdateAutocomplete(newCriteria, newValue, { pinned: false })
  }

  return (
    <CriteriaFields
      autocompleteOptions={unpinnedCriterias}
      criterias={visibleUnpinnedCriteriaFields}
      disabled={disabled}
      onUpdateAutocomplete={handleUpdateAutocomplete}
      onUpdateCriteriaValue={handleUpdateCriteriaValue}
    />
  )
}

UnpinnedCriteriaFields.displayName = 'UnpinnedCriteriaFields'
